import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { getUserLists, resetUserListUsers, resetUserLists, setUserListsPage, toggleUserListModal } from '../../../redux/actions/userLists';
import { Virtuoso } from 'react-virtuoso';

import ActionTypes from '../../../redux/constants/action-types';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import { ListItem, ListItemButton, Radio, TextField, Menu, MenuItem, Divider, FormControlLabel } from '@mui/material';
import useDidMountEffect from '../../utils/useDidMountEffect';
import useDebounce from '../../utils/useDebounceV2';
import { ListItemText } from '@material-ui/core';
import { setMessageUserListsFilter, setShowMessageUserLists } from '../../../redux/actions/message';

const LIST_PER_PAGE = 30;
const virtuosoStyle = { height: '350px' };
const DEBOUNCE_DELAY = 800;

const AddFilterFromModal = ({
    userListsRdx,
    userListsPageRdx,
    listBusyRdx,
    userListsHasMoreRdx,
    userListsTotalRdx,
    userListModalRdx,
    conversationsRdx,
    convIndexRdx,
    showUserListsRdx,
    userListsFilterRdx
}) => {
    const dispatch = useDispatch();

    const [userListSort, setUserListSort] = useState('name');
    const [order, setOrder] = useState('desc');
    const [anchorEl, setAnchorEl] = useState(null);
    const [keyword, setKeyword] = useState('');
    const [busy, setBusy] = useState(false);
    const [showNewForm, setShowNewForm] = useState(false);
    const [editList, setEditList] = useState({});
    const [selectedList, setSelectedList] = useState([]);
    const [showListMenu, setShowListMenu] = useState(false);
    const [userListIds, setUserListIds] = useState([]);

    const getLists = () => {
        const params = {
            page: userListsPageRdx,
            action: userListsRdx && userListsRdx.length > 0
                ? ActionTypes.APPEND_USER_LISTS
                : ActionTypes.SET_USER_LISTS,
            per_page: LIST_PER_PAGE,
            order: order,
            sort: userListSort,
            kw: keyword
        };
        dispatch(getUserLists(params));
    };

    const handleClose = (e, reason) => {
        if (reason && reason === "backdropClick") {
            return;
        };
        dispatch(setShowMessageUserLists(false));
        dispatch(resetUserListUsers());
    };

    const handleListEnd = () => {
        if (listBusyRdx) return;

        if (userListsHasMoreRdx) {
            dispatch(setUserListsPage(userListsPageRdx + 1));
        }
    };

    const handleKeywordChange = e => {
        const value = e.target.value;
        setKeyword(value);
    };

    const debounceUserListSearch = useDebounce(() => {
        dispatch(resetUserLists());
        getLists();
    }, [DEBOUNCE_DELAY]);

    useDidMountEffect(() => {
        debounceUserListSearch();
    }, [keyword]);

    useEffect(() => {
        if (userListsPageRdx) {
            getLists();
        }
    }, [userListsPageRdx]);

    const handleNewUserList = () => {
        setShowNewForm(true);
    };

    const handleListChange = (e, list) => {
        e.stopPropagation();
        e.preventDefault();
        let tmp = [...userListsFilterRdx];
        const index = tmp.findIndex(t => t.id == list.id);
        if (index >= 0) {
            tmp.splice(index, 1);
        } else {
            tmp.push(list);
        }

        dispatch(setMessageUserListsFilter([...tmp]));
    };

    const handleOpenUserListOption = e => {
        setAnchorEl(e.currentTarget);
        setShowListMenu(true);
    };

    const handleUserListSortChange = e => {
        setUserListSort(e.target.value);
    };

    const handleUserOrderChange = e => {
        setOrder(e.target.value);
    };

    useDidMountEffect(() => {
        dispatch(resetUserLists());
        getLists();
    }, [order, userListSort]);

    const handleClearKeyword = () => {
        setKeyword('');
    };

    useEffect(() => {
        if (userListsFilterRdx && userListsFilterRdx.length > 0) {
            const ids = userListsFilterRdx.map(ulist => ulist.id);
            setUserListIds([...ids]);
        } else {
            setUserListIds([]);
        }

        return () => { };
    }, [userListsFilterRdx]);

    return <Dialog
        className='user-list-form'
        open={showUserListsRdx}
        onClose={handleClose}
        maxWidth='sm'
        fullWidth
    >
        <DialogContent>
            <div className='add-user-from-modal'>
                <div>
                    <TextField
                        id="keyword"
                        label="User List Name"
                        value={keyword}
                        onChange={handleKeywordChange}
                        size='small'
                        InputProps={{
                            endAdornment: (
                                !!keyword
                                    ? <IconButton
                                        aria-label="clear text"
                                        onClick={handleClearKeyword}
                                        edge="end"
                                    >
                                        <i style={{ color: '#0097fe' }} className="fal fa-times search-clear-icon"></i>
                                    </IconButton>
                                    : ''
                            ),
                        }}
                    />
                </div>
                <div>
                    <IconButton
                        aria-label="New User List"
                        onClick={handleOpenUserListOption}
                        aria-controls={showListMenu ? 'basic-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={showListMenu ? 'true' : undefined}
                    >
                        <i className="fa-solid fa-bars-sort icon"></i>
                    </IconButton>
                    <Menu
                        anchorEl={anchorEl}
                        id="basic-menu"
                        open={showListMenu}
                        onClose={() => setShowListMenu(false)}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}
                        sx={{
                            '&.MuiMenu-root': {
                                zIndex: 99999
                            }
                        }}
                    >
                        <MenuItem onClick={() => { }}>
                            <Radio
                                value='created_at'
                                checked={userListSort === 'created_at'}
                                name="radio-buttons"
                                inputProps={{ 'aria-label': 'created_at' }}
                                onChange={handleUserListSortChange}
                            /> Recent
                        </MenuItem>
                        <MenuItem onClick={() => { }}>
                            <Radio
                                value='name'
                                checked={userListSort === 'name'}
                                name="radio-buttons"
                                inputProps={{ 'aria-label': 'name' }}
                                onChange={handleUserListSortChange}
                            /> Name
                        </MenuItem>
                        <Divider />
                        <MenuItem onClick={() => { }}>
                            <Radio
                                value='asc'
                                checked={order === 'asc'}
                                name="radio-buttons"
                                inputProps={{ 'aria-label': 'asc' }}
                                onChange={handleUserOrderChange}
                            /> Ascending
                        </MenuItem>
                        <MenuItem onClick={() => { }}>
                            <Radio
                                value='desc'
                                checked={order === 'desc'}
                                name="radio-buttons"
                                inputProps={{ 'aria-label': 'desc' }}
                                onChange={handleUserOrderChange}
                            /> Descending
                        </MenuItem>
                    </Menu>
                </div>
            </div>
            <div style={{ position: 'relative' }}>
                <Virtuoso
                    style={{ height: '50vh' }}
                    totalCount={userListsTotalRdx}
                    data={userListsRdx}
                    atBottomThreshold='150'
                    endReached={handleListEnd}
                    itemContent={(index, uList) => <ListItem
                        key={uList.id}
                        className={`user-lists__item`}
                        style={{
                            overflowX: 'break-word'
                        }}
                        disableGutters
                    >
                        <ListItemButton onClick={(e) => handleListChange(e, uList)}>
                            <FormControlLabel
                                name="radio-buttons"
                                value={uList.id}
                                checked={userListIds.includes(uList.id)}
                                onChange={(e) => handleListChange(e, uList)}
                                control={<Radio />}
                                label={`${uList.name} ${uList.user_count}`}
                            />
                        </ListItemButton>
                    </ListItem>}
                />
            </div>
        </DialogContent>
        <DialogActions style={{ justifyContent: 'flex-end' }}>
            <Button
                onClick={handleClose}
                disabled={busy}
            >Close</Button>
        </DialogActions>
    </Dialog>;
};

const mapStateToProps = state => ({
    userListsRdx: state.userLists.userLists,
    userListsPageRdx: state.userLists.userListsPage,
    listBusyRdx: state.userLists.busy,
    userListsTotalRdx: state.userLists.userListsTotal,
    userListModalRdx: state.userLists.userListModal,
    userListsHasMoreRdx: state.userLists.userListsHasMore,
    conversationsRdx: state.message.convList,
    convIndexRdx: state.message.convIndex,
    showUserListsRdx: state.message.showUserLists,
    userListsFilterRdx: state.message.userListsFilter
});

export default connect(mapStateToProps)(AddFilterFromModal);